import { useNavigate } from 'react-router';
import { isSPARoute } from '../../helpers/routing/route.helpers';

// For when we need to trigger navigation programmatically.
// Will handle our link object and navigate them externally if needed.
export const useNavigation = () => {
	const navigate = useNavigate();
	return (to: string | number, replace?: boolean) => {
		if (typeof to === 'number') {
			// if a number, then treat as delta
			navigate(to);
			return;
		}
		const isOnlyParamChange = to.startsWith('?');
		const isSPAEnabled = isSPARoute(to);
		if (isOnlyParamChange || isSPAEnabled) {
			if (replace) {
				navigate(to, { replace: true });
			} else {
				navigate(to);
			}
		} else {
			if (replace) {
				window.location.replace(to);
			} else {
				window.location.assign(to);
			}
		}
	};
};
